import cx from "classnames"
import * as styles from "components/NestableList/NestableList.css?module"

export const NestableList = ({ children, className, ...props }) => {
  return (
    <ul className={cx(className, "list-disc", styles.NestableList)} {...props}>
      {children}
    </ul>
  )
}
